<template>
  <div id="admin-system-profession" v-loading="loading">
    <!-- 专业设置 -->
    <div class="left">
      <div class="top">
        <el-input
          v-model="searchPro"
          placeholder="可输入关键字搜索专业"
          suffix-icon="el-icon-search"
        ></el-input>
      </div>
      <div class="tree customScrollBar">
        <el-tree
          v-if="professionTree.length > 0"
          :data="professionTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          ref="tree"
          :filter-node-method="filterNode"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i class="iconfont icon-24gf-folderOpen" v-if="!node.isLeaf"></i>
            <i v-else class="iconfont icon-24gf-fileText"></i>
            <span>{{ node.label }}</span>
            <span class="perch-active"></span>
            <el-dropdown>
              <i class="iconfont icon-androidgengduo"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in professionOper"
                  :key="index"
                >
                  <div @click="clickMore(data, item.key)" style="width: 100%">
                    {{ item.title }}
                  </div></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </el-tree>
        <div class="add_but" @click="addProfession">
          <i class="el-icon-plus"></i> 添加专业
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top">
        {{ data.name
        }}<span v-if="data.alias && data.alias.length > 0" class="alias"
          >【
          <span v-for="(item, index) in data.alias" :key="index"
            >{{ index == 0 ? "" : "," }}{{ item }}</span
          >
          】</span
        >
      </div>
      <div class="buts" v-if="userOper.length > 0">
        <div
          :class="{ but: true }"
          v-for="(item, index) in userOper"
          :key="index"
          @click="clickMore(data, item.key)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="table">
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          style="width: 100%"
          height="100%"
          border
          @selection-change="handleSelectionChange"
          ><el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column width="55" label="序号" type="index">
          </el-table-column>
          <template
            ><el-table-column
              v-for="(item, index) in tableMenu"
              :property="item.key"
              :key="index"
              :label="item.name"
              show-overflow-tooltip
              style="background-color: #eee"
            >
              <template slot-scope="scope">
                <div class="diy_cell">
                  {{ scope.row[item.key] }}
                </div>
              </template>
            </el-table-column>
          </template>
          <template>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row, but.active)"
                  type="text"
                  size="small"
                  v-for="(but, index) in tableButton"
                  :key="index"
                  >{{ but.text }}</el-button
                >
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @current-change="initTable"
          :current-page.sync="pageData.currentPage"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next,jumper"
          :total="pageData.total"
        >
        </el-pagination>
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as professionalData from "./professional.js";
import * as base from "../../js/base.js";
export default {
  data() {
    return {
      loading: true,
      searchPro: "", // 专业模糊搜索
      professionTree: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      professionOper: [
        { title: "编辑专业", key: "edit_profession" },
        { title: "添加子专业", key: "add_profession_childer" },
        // { title: "设置上级", key: "set_lead" },
        { title: "删除专业", key: "delete_profession" },
      ],
      data: {
        id: "", // 专业ID
        name: "专业名称",
      },
      userOper: [
        { title: "添加子专业 ", key: "add_profession_childer" },
        { title: "添加学员", key: "add_user" },
        { title: "移除学员", key: "delete_user" },
        { title: "导入学员", key: "import_user" },
        { title: "删除专业", key: "delete_profession" },
      ],
      tableMenu: this.$systemBaseData.getTableMenuData("profession"),
      tableData: [],
      tableButton: [{ text: "移除学员", active: "delete_user" }],
      multipleSelection: [],
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 20, // 总条目数
      },
      dialogData: {
        flag: false,
        title: "添加子专业",
        width: "50%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_add_child_pro" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  watch: {
    searchPro(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  专业 21
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "21" },
        });
        this.professionOper = base.returnAllButton(
          this.professionOper,
          resultData,
          "title"
        );
        this.userOper = base.returnAllButton(
          this.userOper,
          resultData,
          "title"
        );
        this.tableButton = base.returnAllButton(
          this.tableButton,
          resultData,
          "text"
        );
      } catch (error) {}
    },
    /**
     * 获取专业树
     */
    async getProfessionalTree() {
      this.loading = true;
      try {
        let data = await this.$request({
          url: "/professional/getProfessionalTree",
          method: "post",
          data: null,
        });
        this.professionTree = data;
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 树节点的过滤器
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /**
     * 专业树点击事件
     */
    async handleNodeClick(data) {
      console.log(data);
      this.data = data;
      await this.initTable();
    },
    /**
     * 专业的更多的点击事件
     */
    async clickMore(data, key) {
      console.log("点击更多", data);
      this.dialogData.tempData = data;
      switch (key) {
        case "edit_profession":
          // 编辑专业
          this.dialogData.dialogData = professionalData.getDialogDataForPage(
            key
          );
          this.dialogData.dialogData = this.$baseData.json2array(
            this.dialogData.dialogData,
            this.dialogData.tempData
          );
          this.dialogData.title = "编辑专业";
          this.dialogData.width = "40%";
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_edit_pro" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "add_profession_childer":
          // 添加子专业
          this.dialogData.dialogData = professionalData.getDialogDataForPage(
            key
          );
          this.dialogData.title = "添加子专业";
          this.dialogData.width = "40%";
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_edit_child_pro" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "add_user":
          // 添加学员
          try {
            let userList = await this.$request({
              url: "/user/getUserDropList",
              method: "post",
              data: null,
            });
            this.dialogData.dialogData = professionalData.getDialogDataForPage(
              key
            );
            this.dialogData.dialogData[0].userAllList = userList;
            let ud = [];
            if (this.tableData.length > 0) {
              this.tableData.forEach((element) => {
                let dd = {
                  id: element.id,
                  name: element.name,
                };
                ud.push(dd);
              });
            }
            this.dialogData.dialogData[0].value = ud;
            this.dialogData.title = "添加学员";
            this.dialogData.width = "55%";
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_add_user" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
          } catch (error) {
            this.$message.error(error.message);
          }

          break;
        case "delete_profession":
          // 删除专业
          this.$confirm(
            "删除专业,将同步删除所有子专业,且将解除专业下所有用户的专业所属关系, 是否继续?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(async () => {
              try {
                requestData = {
                  id: data.id,
                };
                let data = await this.$request({
                  url: "/professional/deleteProfessionalById",
                  method: "post",
                  data: requestData,
                });
                this.$message({
                  type: "success",
                  message: "专业删除成功!",
                });
                await this.getProfessionalTree();
              } catch (error) {
                console.log(error);
                this.$message.error(error.message);
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
          break;
        case "delete_user":
          // 移除学员
          // 1 多选删除  判断多选框中是否都值
          if (this.multipleSelection.length == 0) {
            this.$message.warning("请先选择要移除的学员!");
            return;
          }
          await this.deleteUserFromProfessional();
          break;
        case "import_user":
          // 导入学员至当前部门
          this.dialogData.dialogData = [
            {
              type: "import",
              value: {
                type: "7",
                way: "0",
                fileUrl: "", // 已上传的模板路径
                fileName: "", // 已上传的模板名称
                wayOptions: [{ label: "EXCEL 导入", value: "0" }],
              },
            },
          ];
          this.dialogData.title = "部门学员导入";
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_import" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        default:
          break;
      }
    },
    addProfession() {
      this.dialogData.dialogData = professionalData.getDialogDataForPage(
        "add_profession_childer"
      );
      this.dialogData.title = "添加专业";
      this.dialogData.width = "40%";
      this.dialogData.buttonList = [
        { text: "确定", active: "makesure_add_pro" },
        { text: "取消", active: "cancel" },
      ];
      this.dialogData.flag = true;
    },
    /**
     * 移除学员
     */
    deleteUserFromProfessional() {
      this.$confirm("是否将当前所选学员从该专业中移除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            let userList = [];
            this.multipleSelection.forEach((element) => {
              userList.push(element.userId);
            });
            let requestData = {
              proId: this.data.id,
              userList: userList,
            };
            let dd = await this.$request({
              url: "/professional/deleteUserFromProfessional",
              method: "post",
              data: requestData,
            });
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.multipleSelection = [];
            this.handleNodeClick(this.data);
          } catch (error) {
            this.$message.error(error.message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /**
     * 学员表格中的点击事件
     */
    async handleClick(user, active) {
      this.multipleSelection = [];
      this.multipleSelection.push(JSON.parse(JSON.stringify(user)));
      switch (active) {
        case "delete_user":
          // 删除当前学员与该专业之间的关系
          await this.deleteUserFromProfessional();
          break;

        default:
          break;
      }
    },
    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      let requestData = {};
      let resultData = {};
      switch (active) {
        case "makesure_edit_pro":
          // 确定编辑专业
          try {
            requestData = {
              id: this.dialogData.tempData.id,
              fatherId: this.dialogData.tempData.fatherId,
            };
            this.dialogData.dialogData.forEach((element) => {
              if (element.isNotNull && element.value == "") {
                throw { message: element.title + "不可为空!" };
              }
            });
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            resultData = await this.$request({
              url: "/professional/saveOrUpdateProfessional",
              method: "post",
              data: requestData,
            });
            await this.getProfessionalTree();
            this.colseDialog();
            this.$message.success("操作成功!");
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "makesure_edit_child_pro":
          // 添加子专业
          try {
            requestData = {
              id: "",
              fatherId: this.dialogData.tempData.id,
            };
            this.dialogData.dialogData.forEach((element) => {
              if (element.isNotNull && element.value == "") {
                throw { message: element.title + "不可为空!" };
              }
            });
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            resultData = await this.$request({
              url: "/professional/saveOrUpdateProfessional",
              method: "post",
              data: requestData,
            });
            await this.getProfessionalTree();
            this.colseDialog();
            this.$message.success("操作成功!");
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "makesure_add_pro":
          // 添加专业
          try {
            requestData = {
              id: "",
              fatherId: "",
            };
            this.dialogData.dialogData.forEach((element) => {
              if (element.isNotNull && element.value == "") {
                throw { message: element.title + "不可为空!" };
              }
            });
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            resultData = await this.$request({
              url: "/professional/saveOrUpdateProfessional",
              method: "post",
              data: requestData,
            });
            await this.getProfessionalTree();
            this.colseDialog();
            this.$message.success("操作成功!");
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "makesure_add_user":
          // 确认添加学员
          try {
            console.log(this.dialogData.dialogData[0].value);
            let dd = JSON.parse(
              JSON.stringify(this.dialogData.dialogData[0].value)
            );
            let userList = [];
            dd.forEach((element) => {
              userList.push(element.id);
            });
            requestData = {
              proId: this.dialogData.tempData.id,
              userList: userList,
            };
            resultData = await this.$request({
              url: "/professional/addProfessionalUser",
              method: "post",
              data: requestData,
            });
            this.dialogData.flag = false;
            this.$message.success("操作成功!");
            this.handleNodeClick(this.data);
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "makesure_import":
          // 确定导入部门学员
          try {
            requestData = {
              filePath: this.dialogData.dialogData[0].value.fileUrl,
            };
            resultData = await this.$request({
              url: "/professional/importUserForProfessional",
              method: "post",
              data: requestData,
            });
            this.dialogData.dialogData = [
              {
                title: "导入成功",
                value: resultData.successData.length + "条",
                type: "text",
                data: resultData.successData,
              },
              {
                title: "导入失败数据",
                type: "table",
                value: resultData.errorData,
                menu: [
                  { key: "name", name: "姓名" },
                  { key: "cause", name: "失败原因" },
                ],
              },
            ];
            this.dialogData.buttonList = [
              { text: "导入成功数据", active: "makesure_import_success" },
              { text: "取消", active: "cancel" },
            ];
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "makesure_import_success":
          // 确定导入成功的数据
          requestData = this.dialogData.dialogData[0].data;
          resultData = await this.$request({
            url: "/professional/makesureImportUserProfessional",
            method: "post",
            data: requestData,
          });
          this.dialogData.flag = false;
          this.$message.success("操作成功!");
          this.handleNodeClick(this.data);
          break;

        case "cancel":
          // 关闭
          this.colseDialog();
          break;
        default:
          break;
      }
    },
    /**
     * 获取当前专业的所有用户组成
     */
    async initTable() {
      try {
        let requestData = {
          proId: this.data.id,
          pageSize: this.pageData.pageSize,
          currentPage: this.pageData.currentPage,
        };
        let dd = await this.$request({
          url: "/professional/getAllUserListByProfessional",
          method: "post",
          data: requestData,
        });
        this.tableData = dd.tableData;
        this.pageData.total = dd.total;
        this.tableData.forEach((element) => {
          element.leverl = element.leverl == "" ? "--" : element.leverl;
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 表格多选事件
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getProfessionalTree();
    if (this.professionTree.length > 0) {
      await this.handleNodeClick(this.professionTree[0]);
    }
  },
};
</script>

<style lang="less" scoped>
#admin-system-profession {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .left {
    width: 300px;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    > .top {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
    }
    > .tree {
      width: 100%;
      height: 0;
      flex: 1;
      overflow-y: auto;
      margin-top: 15px;
      /deep/ .el-tree-node__content {
        height: 40px;
      }
      .custom-tree-node {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        i {
          margin-right: 5px;
        }
      }
    }
  }
  > .right {
    width: 0;
    flex: 1;
    height: 100%;
    margin-left: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    > .top {
      width: auto;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 10px;
      border-left: 5px double #333;
      box-sizing: border-box;
      font-size: 15px;
      font-weight: bold;
      margin-left: 20px;
      > .alias {
        margin-left: 10px;
        font-size: 14px;
      }
    }
    > .buts {
      width: 100%;
      margin: 10px 0;
      height: 50px;
      background-color: #f0f0f0;
      border-radius: 2px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      > .but {
        width: auto;
        height: 30px;
        padding: 0 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: @baseColor;
        cursor: pointer;
        transition: 0.3s;
        margin: 0 5px;
        border: 1px solid #e6e6e6;
        background-color: #fff;
        &:hover {
          text-decoration: underline;
          text-underline-offset: 3px;
        }
      }
      > .err {
        color: #ff5202;
      }
    }
    > .table {
      width: 100%;
      height: 0;
      flex: 1;
      margin-top: 10px;
      .diy_cell {
        display: flex;
        height: 100%;
        line-height: 28px !important;
        > .is_lead {
          width: auto;
          height: 20px;
          font-size: 13px;
          padding: 0px 8px;
          line-height: 18px !important;
          box-sizing: border-box;
          border: 1px solid #ffd399;
          background-color: #fdf8f2;
          margin-left: 10px;
          position: relative;
        }
      }
    }
    > .page {
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 20px;
      border-top: @cut-off-rule;
      box-sizing: border-box;
    }
  }
}
</style>